import { Component, OnInit, NgZone } from '@angular/core';
import { GeoJsonDataService } from '../../services/geo-json-data.service';
import { FlowDataService } from '../../services/flow-data.service';
import { ReachSelectService } from '../../services/reach-select.service';
import { HydroConditionService } from 'src/app/services/hydro-condition.service';
import L, { icon, GeoJSON, latLng, Layer, marker, tileLayer, polyline, control, LatLngBounds, point } from 'leaflet';

var BreakException = {};
/* Set Various Marker Icon Styles*/

var dropMarker = icon({
  iconSize: [7, 12],
  iconAnchor: [7, 12],
  shadowAnchor: [5, 10],
  shadowSize: [5, 10],
  iconUrl: 'assets/leaflet/images/droplet-icon.png',
  shadowUrl: 'assets/leaflet/images/drop-icon-shadow.png',
});

@Component({
    selector: 'ngx-map',
    templateUrl: 'ngx-map.component.html',
    styleUrls: [ 'ngx-map.component.scss']
})

export class NgxMapComponent implements OnInit {

  public efdate = ''; //used to store the data selected
  public ef200count = 0; // counter for reaches with excess flow above 200cfs threshold

  date: string;
  ReachLeaf: any;
  ReachLeaf2: any;
  LeafFacility: any;
  LeafPointOfDiversion: any;
  geoJsonDataReach: any;
  geoJsonDataFacility: any;
  geoJsonDataPointOfDiversion: any;
  flowData: any;
  ReachNumber: string;
  correlation: object;
  hydroCondition: string;

  constructor(private flowDataObject: FlowDataService, private geoJsonDataObject: GeoJsonDataService, private reachObject : ReachSelectService, private zone: NgZone, private hydroConditionService: HydroConditionService) {}

  markers: Layer[] = [];
  reaches: Layer[] = [];
  facilities: Layer[] = [];
  pointsOfDiversion: Layer[] = [];
  highlights: Layer[] = [];


  // ProjectFacility Marker Style
  geojsonMarkerOptionsFacilities = {
    radius: 3,
    fillColor: "#ff7800",
    color: "#000",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8
    };

    // PermitPointOfDiversion Marker Style
    geojsonMarkerOptionsPODs = {
        radius: 3,
        fillColor: "#2278ff",
        color: "#000",
        weight: 1,
        opacity: 1,
        fillOpacity: 0.8
    };

  // Open Street Map definitions
  osm = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' });

  // Values to bind to Leaflet Directive
  options = {
    layers: [this.osm],
    zoom: 7,
    maxZoom: 12,
    minZoom: 7,
    maxBounds: new LatLngBounds(latLng(39.93501296038254, -104.0625), latLng(43.02071359427862, -94.16381835937501)),
    center: latLng(41.5, -99.11),
    zoomControl: false
  };

  layersControl = {
    baseLayers: {
      'Open Street Map': this.osm,
    },
    overlays: {}
  }

  ngOnInit() {

    this.geoJsonDataObject.currentGeoJsonReach.subscribe(geoJson => {
      this.geoJsonDataReach = geoJson;
      this.setSubsciptions();
    });

      this.geoJsonDataObject.currentGeoJsonFacility.subscribe(geoJson => {
          this.geoJsonDataFacility = geoJson;
          this.setSubsciptions();
      });

      this.geoJsonDataObject.currentGeoJsonPointOfDiversion.subscribe(geoJson => {
          this.geoJsonDataPointOfDiversion = geoJson;
          this.setSubsciptions();
      });

    this.reachObject.currentReach.subscribe(ReachNumber => {
      this.ReachNumber = ReachNumber;
      this.setSpecificReach(ReachNumber);
      this.setSubsciptions();
    });

    this.flowDataObject.currentFlow.subscribe(flowData => {
      this.flowData = flowData;
      this.setSubsciptions();
    });

    this.hydroConditionService.currentHydroCondition.subscribe(hydroCondition => {
        if (hydroCondition) { //can replace "if" with "optional chaining" after Angular 9/typescript upgrade
            this.hydroCondition = hydroCondition.demandCondition;
        }
    });

  }

  handleEvent(eventType: string) {
    // console.log('leaflet ' + eventType +'event intercepted here');
  }

    setSubsciptions = () => {
    //if (Array.isArray(this.geoJsonDataFacility) && this.geoJsonDataFacility.length) {
    //    for (var i = 0; i < this.geoJsonDataFacility.length; i++) {
    //        var a = this.geoJsonDataFacility[i];
    //        var ll = L.latLng(a.geometry.coordinates[1], a.geometry.coordinates[0]);
    //        this.LeafFacility = L.circleMarker(ll, this.geojsonMarkerOptionsFacilities);
    //        this.facilities.push(this.LeafFacility);
    //    }
    //}
    //if (Array.isArray(this.geoJsonDataPointOfDiversion) && this.geoJsonDataPointOfDiversion.length) {
    //    for (var i = 0; i < this.geoJsonDataFacility.length; i++) {
    //        var a = this.geoJsonDataFacility[i];
    //        var ll = L.latLng(a.geometry.coordinates[1], a.geometry.coordinates[0]);
    //        this.LeafFacility = L.circleMarker(ll, this.geojsonMarkerOptionsPODs);
    //        this.facilities.push(this.LeafFacility);
    //    }
    //}
    if (Array.isArray(this.geoJsonDataReach) && this.geoJsonDataReach.length) {
      if (Array.isArray(this.flowData) && this.flowData.length) {
        this.highlights = [];
        this.correlation = {};
        //this.flowData.forEach(function (flowDataItem) {
        //  this.correlation[flowDataItem.ReachNumber] = flowDataItem.ReachNumber;
        //});

        if (this.ReachNumber) {
          this.generateHighlight(this.ReachNumber);
          }

        this.reaches = [];
        this.facilities = [];
        this.pointsOfDiversion = [];
        this.efdate = this.flowData[0].ExcessFlowDate.toString();
        this.ef200count = 0;

        /* Generated gradient array using https://codepen.io/BangEqual/pen/VLNowO */
        let gradient = ["#330acc","#661499","#991f66","#cc2933"];
        let thicknessArr = [2.5,3,3.5,4];


        var r9clr = '';
        var r9wgt = 0;

        /* Create object of reach geometry by ReachNumber */
        let geoJsonReach: any = {};
        this.geoJsonDataReach.forEach(function (geoReach) {
          var pts = [];
          geoReach["geometry"]["coordinates"].forEach(function (x: any[]) {
            pts.push(GeoJSON.coordsToLatLngs(x));
          });
          geoJsonReach[geoReach["properties"]["ReachNumber"]] = pts;
        });


        this.flowData.forEach((flowDataItem) => {

        /* Style reach based on excessflow value */
          var val = Number(flowDataItem.ExcessFlowFromMaxDemand);

          if (val > 200) {
            this.ef200count += 1;
          }

          let closest;

          if (flowDataItem.ExcessFlowFromMaxDemand < 100)  {closest = 0;}
          else if (flowDataItem.ExcessFlowFromMaxDemand < 500)  {closest = 1;}
          else if (flowDataItem.ExcessFlowFromMaxDemand < 1000) {closest = 2;}
          else {closest = 3;}

          let clr = gradient[closest];
          let wgt = thicknessArr[closest];

          // Reach 0 needs the same styling as Reach 9
          if (flowDataItem.ReachNumber == 9) {
            r9clr = clr;
            r9wgt = wgt;
          }

          /* Create polyline */
          this.ReachLeaf = polyline(geoJsonReach[flowDataItem.ReachNumber], {
            color: clr,
            weight: wgt,
            // opacity: 0.75,
            opacity: 1,
            smoothFactor: 1
          }).bindTooltip('Reach ' + flowDataItem.ReachNumber);

          this.ReachLeaf.bindPopup("<div style='width:200px;'><table class='table table-striped table-condensed table-bordered w-100'><tr><td><strong>Reach: " + flowDataItem.ReachNumber + " - " + flowDataItem.ExcessFlowDate + "</strong></td></tr><tr><td>Excess Flow:" + flowDataItem.ExcessFlowFromMaxDemand + "</td></tr></table></div>");

          this.ReachLeaf.options['gage_data'] = flowDataItem;
          this.ReachLeaf.on('popupopen', (e) => {
            this.zone.run(() => {
              //e.target.options.gage_data.selected = true;
              this.selectexcessFlowDataSubject();
              if (e.target.options.gage_data.ReachNumber !== this.ReachNumber) {
                this.reachObject.selectReach(e.target.options.gage_data.ReachNumber);
              }
            });
          });
          this.ReachLeaf.on('popupclose', (e) => {
            this.zone.run(() => {
              //e.target.options.gage_data.selected = false;
              this.selectexcessFlowDataSubject();
            });
          });
          this.reaches.push(this.ReachLeaf);
        });

        // Add the Reach 0, non interactive reach upstream of Reach 9
        this.ReachLeaf = polyline(geoJsonReach[0], {
          color: r9clr,
          weight: r9wgt,
          // opacity: 0.75,
          opacity: 1,
          smoothFactor: 1
        });
        this.reaches.push(this.ReachLeaf);

        this.ReachLeaf = polyline(geoJsonReach[22], {
          color: "blue",
          weight: 3,
          // opacity: 0.75,
          opacity: 1,
          smoothFactor: 1
        }).bindTooltip('Reach 22');;
        this.reaches.push(this.ReachLeaf);

      } else {
        this.generateDatalessMap();
      }
    }
  }

  selectexcessFlowDataSubject() {
    try {
      this.flowData.forEach(element => {
        element.selected = false;
        if (element.ReachNumber === this.ReachNumber) {
          element.selected = true;
          this.ReachNumber = element.ReachNumber;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
  }

  setSpecificReach(newReach: string) {
    if (this.flowData) {
      let i = 0;
      this.flowData.forEach(element => {
        if (!i) i=0;
        element.selected = false;
        if (element.ReachNumber === newReach) {
          this.zone.run(() => {
            element.selected = true;
            this.reaches[i].openPopup();
          });
        }
        i += 1;
      });
    }
  }

  generateHighlight(ReachNumber) {
    this.highlights = [];
    let pts = [];
    this.geoJsonDataReach.forEach((geoReach) => {
      if (geoReach["properties"]["ReachNumber"] == ReachNumber) {
        geoReach["geometry"]["coordinates"].forEach(function (x: any[]) {
          pts.push(GeoJSON.coordsToLatLngs(x));
        });
      }
    });
    this.flowData.forEach((flowDataItem) => {
      let clr1;
      let wgt1;
      clr1 = "yellow";
      wgt1 = 10;

      /* Create polyline */
      this.ReachLeaf2 = polyline(pts, {
        color: clr1,
        weight: wgt1,
        opacity: 1,
        smoothFactor: 1
      });

      this.ReachLeaf2.options['gage_data'] = flowDataItem;

      this.highlights.push(this.ReachLeaf2);
    });

  }

  generateDatalessMap() {

    this.highlights = [];

    for (let i=0; i < this.geoJsonDataReach.length; i++) {
      let pts = [];

      this.geoJsonDataReach[i]["geometry"]["coordinates"].forEach(function (x: any[]) { pts.push(GeoJSON.coordsToLatLngs(x)); });

      /* Create polyline */
      this.ReachLeaf2 = polyline(pts, {
        color: "blue",
        weight: 3,
        opacity: 1,
        smoothFactor: 1
      });

      this.highlights.push(this.ReachLeaf2);
    }

  }

  mapReady(map: L.Map) {
    map.addControl(control.zoom({ position: 'bottomleft' }));
  }
}
